import React from 'react';
import { routes } from 'routes';
import { colors } from 'globalStyle';
import { Ghost } from 'components/Buttons';
import { Title, Text } from 'components/Texts';
// import { GUIA_INVERSION } from 'types/fileType';
import { GrayA } from 'components/Buttons/Ghost';
import { Box, Grid, styled } from '@material-ui/core';
import ErrorIcon from 'assets/icons/cancel-icon-primary.svg';
import CurrencyIcon from 'assets/icons/money-sign-primary.svg';

export default function ProjectInfoCards({ isDesktop }) {
  return (
    <Grid container justify="space-between" style={{ rowGap: '30px' }}>
      <ProjectInfoCard
        img={CurrencyIcon}
        isDesktop={isDesktop}
        title="¿Sabes cómo invertir?"
        text="En esta guía te contamos todo lo que debes saber para que inviertas."
        link={(
          <GrayA
            underline
            size={13}
            // target="_blank"
            href={routes.home}
            color={colors.primary}
            // rel="noopener noreferrer"
          >
            Ver guía
          </GrayA>
        )}
        imgProps={{
          marginRight: isDesktop && '50px',
          width: isDesktop ? '41px' : '27px',
          height: isDesktop ? '69px' : '52.4px',
        }}
      />
      <ProjectInfoCard
        img={ErrorIcon}
        isDesktop={isDesktop}
        title="Reporte de incidencias"
        text="En caso que no carguen los videos y las fotografías, o no funcione algún botón, cuéntanos para solucionarlo."
        link={(
          <Ghost
            underline
            size={13}
            color={colors.primary}
            href={routes.message.contactUs}
          >
            Reportar incidencia
          </Ghost>
        )}
        imgProps={{
          width: isDesktop ? '54px' : '30px',
          height: isDesktop ? '54px' : '30px',
        }}
      />
    </Grid>
  );
}

const ProjectInfoCard = ({
  isDesktop, img, imgProps, title, text, link,
}) => (
  <ProjectInfoCardContainer item container isDesktop={isDesktop}>
    <Box
      alt=""
      src={img}
      component="img"
      {...imgProps}
    />
    <Grid container justify="flex-end">
      <Title size={isDesktop ? 18 : 14}>
        {title}
      </Title>
      <Text
        mb={isDesktop ? 6 : 11}
        mt={isDesktop ? 20 : 9.5}
        size={isDesktop ? 15 : 14}
      >
        {text}
      </Text>
      {link}
    </Grid>
  </ProjectInfoCardContainer>
);

const ProjectInfoCardContainer = styled(Grid)(({ isDesktop }) => ({
  flexWrap: 'nowrap',
  alignItems: 'center',
  borderRadius: '20px',
  background: colors.WHITE,
  width: isDesktop ? '48.6%' : '100%',
  border: `1px solid ${colors.GRAY_10}`,
  columnGap: isDesktop ? '17px' : '30px',
  boxShadow: '0px 4px 30px 0px rgba(0, 0, 0, 0.06)',
  padding: isDesktop ? '40px 40px 15px 45px' : '30px 20px 14px 20px',
}));
